
import { BASE_URL } from "../../../helpers/config";
import { showToast, showAlert } from "../../../utils/helpers/ShowToast";
import authorizedAxios from "../../../helpers/authorizedAxios";
export const SET_CITIES = "SET_CITIES";
export const SET_CITIES_LOADING = "SET_CITIES_LOADING";
export const SET_CITIES_ERROR = "SET_CITIES_ERROR";

export const fetchCities = (limit = 100, page = 1, search = "", province_id = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_CITIES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/cities", {
        params: { limit, page, search, province_id }
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_CITIES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CITIES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_CITIES_LOADING, status: false });
    }
  };
};

export const addCity = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CITIES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/cities`, data), {
        loading: "Menyimpan data...",
        success: "Data Kabupaten/Kota berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data Kabupaten/Kota!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kabupaten/Kota berhasil ditambahkan!"
        });
        dispatch(fetchCities());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CITIES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_CITIES_LOADING, status: false });
    }
  };
};

export const updateCity = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_CITIES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/cities/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data Kabupaten/Kota berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data Kabupaten/Kota!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kabupaten/Kota berhasil diupdate!"
        });
        dispatch(fetchCities());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CITIES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_CITIES_LOADING, status: false });
    }
  };
};

export const deleteCity = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_CITIES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/cities/${id}`), {
        loading: "Menghapus data...",
        success: "Data Kabupaten/Kota berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kabupaten/Kota berhasil dihapus!"
        });
        dispatch(fetchCities());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_CITIES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_CITIES_LOADING, status: false });
    }
  };
};
